import * as actions from './actions';

const initialState = {
	nodehandlers: {},
	flows: {},
	triggerDefinitions: {},
	flowValidation: {},
	debug: {}
};

function reduceFetchFlowNodeHandlers(state) {
	return {
		...state,
		nodehandlers: {
			...state.nodehandlers,
			loading: true,
			error: false
		}
	};
}

function reduceFetchFlowNodeHandlersSuccess(state, action) {
	return {
		...state,
		nodehandlers: {
			loading: false,
			error: false,
			errorDetail: null,
			handlers: action.payload
		}
	};
}

function reduceFetchFlowNodeHandlersError(state, action) {
	return {
		...state,
		nodehandlers: {
			...state.nodehandlers,
			loading: false,
			error: true,
			errorDetail: action.payload
		}
	};
}

function reduceFetchFlowTriggerDefinitions(state) {
	return {
		...state,
		triggerDefinitions: {
			definitions: null,
			loading: true,
			error: false
		}
	};
}

function reduceFetchFlowTriggerDefinitionsSuccess(state, action) {
	return {
		...state,
		triggerDefinitions: {
			loading: false,
			error: false,
			errorDetail: null,
			definitions: action.payload
		}
	};
}

function reduceFetchFlowTriggerDefinitionsError(state, action) {
	return {
		...state,
		triggerDefinitions: {
			...state.triggerDefinitions,
			loading: false,
			error: true,
			errorDetail: action.payload
		}
	};
}

function reduceFetchFlow(state, action) {
	return {
		...state,
		flows: {
			...state.flows,
			[action.payload.flowId]: {
				loading: true,
				error: false,
				flowId: action.payload.flowId
			}
		}
	};
}

function reduceFetchFlowSuccess(state, action) {
	// build a data-structure of triggers in memory from the list
	// of triggers from our bindings.  this is temporary and expect
	// that bindings will pass up this data-structure.
	const { flow, flowId, flowTriggers } = action.payload;

	// store the flow triggers are part of the flow
	flow.triggers = flowTriggers.triggers;

	return {
		...state,
		flows: {
			...state.flows,
			[action.payload.flowId]: {
				loading: false,
				error: false,
				errorDetail: null,
				flowId,
				flow,
				flowTriggers
			}
		}
	};
}

function reduceFetchFlowError(state, action) {
	return {
		...state,
		flows: {
			...state.flows,
			[action.payload.flowId]: {
				loading: false,
				error: true,
				errorDetail: action.payload,
				flowId: null,
				flow: null,
				flowTriggers: null
			}
		}
	};
}

function reduceValidateFlow(state) {
	return {
		...state,
		flowValidation: {
			loading: true,
			error: false,
			validation: null
		}
	};
}

function reduceValidateFlowSuccess(state, action) {
	return {
		...state,
		flowValidation: {
			loading: false,
			error: false,
			validation: action.payload
		}
	};
}

function reduceValidateFlowError(state, action) {
	return {
		...state,
		flowValidation: {
			loading: false,
			error: true,
			errorDetail: action.payload,
			validation: null
		}
	};
}

function clearValidateFlow(state) {
	return {
		...state,
		flowValidation: {
			loading: false,
			error: false,
			validation: null
		}
	};
}

function reduceSaveFlow(state, action) {
	const newState = {
		...state,
		flows: {
			...state.flows,
			[action.payload.flowId]: {
				...state.flows[action.payload.flowId],
				saving: true,
				saveError: false,
				saveErrorDetail: null,
				flowId: action.payload.flowId
			}
		}
	};
	return newState;
}

function reduceSaveFlowError(state, action) {
	const newState = {
		...state,
		flows: {
			...state.flows,
			[action.payload.flowId]: {
				...state.flows[action.payload.flowId],
				saving: false,
				saveError: true,
				saveErrorDetail: action.payload
			}
		}
	};
	return newState;
}

function reduceSaveFlowSuccess(state, action) {
	return {
		...state,
		flows: {
			...state.flows,
			[action.payload.flowId]: {
				...state.flows[action.payload.flowId],
				saving: false,
				saveError: false,
				saveErrorDetail: null
			}
		}
	};
}

function reduceSaveFlowCompleted(state, action) {
	return {
		...state,
		flows: {
			...state.flows,
			[action.payload.flowId]: {
				...state.flows[action.payload.flowId],
				saving: false,
				saveError: false,
				saveErrorDetail: null,
				saveComplete: true,
				saveCompletedContext: action.payload.saveCompletedContext
			}
		}
	};
}

function reduceNewFlow(state, action) {
	const name = action.payload.friendlyName
		|| `${action.payload.group} - ${action.payload.method} ${action.payload.path}`;

	let parameter;

	if (action.payload.friendlyName) {
		// unbound Flow created with +Flow button
		parameter = {
			properties: {
				request: {
					description: 'The request'
				},
				config: {
					type: 'object',
					description: 'The service\'s configuration'
				},
				env: {
					type: 'object',
					description: 'The host OS environment'
				}
			},
			additionalProperties: false
		};
	} else {
		// Flow bound to an Endpoint
		parameter = {
			properties: {
				params: {
					type: 'object',
					description: 'The parameters from the endpoint.'
				},
				request: {
					type: 'object',
					description: 'The HTTP request.'
				},
				config: {
					type: 'object',
					description: 'The service\'s configuration'
				},
				env: {
					type: 'object',
					description: 'The host OS environment'
				}
			},
			additionalProperties: false,
			required: [
				'request',
				'config',
				'env',
				'params'
			]
		};
	}

	const flow = {
		schemaVersion: '4',
		info: {
			name
		},
		parameter,
		start: null,
		nodes: {}
	};

	return {
		...state,
		flows: {
			...state.flows,
			$$_new_flow: {
				flow,
				flowId: '$$_new_flow',
				loading: false,
				error: false
			}
		}
	};
}

function reduceCreateFlow(state, action) {
	const newState = {
		...state,
		flows: {
			...state.flows,
			[action.payload.flowId]: {
				...state.flows[action.payload.flowId],
				saving: true,
				saveError: false,
				saveErrorDetail: null,
				flowId: action.payload.flowId
			}
		}
	};
	return newState;
}
// Intentionally replace the whole debug state for each reducer
function reduceDebugFlowStart(state) {
	const newState = {
		...state,
		debug: {
			loading: true
		}
	};
	return newState;
}

function reduceDebugFlowRespond(state, action) {
	const newState = {
		...state,
		debug: {
			response: { value: action.payload },
			loading: false
		}
	};
	return newState;
}

function reduceDebugFlowStop(state) {
	const newState = {
		...state,
		debug: {
			...state.debug,
			loading: false
		}
	};
	return newState;
}

function reduceDebugFlowClear(state) {
	const newState = {
		...state,
		debug: {}
	};
	return newState;
}

function reduceDebugFlowError(state, action) {
	const newState = {
		...state,
		debug: {
			error: true,
			errorDetail: action.payload
		}
	};
	return newState;
}

function reduceDeleteFlowError(state, action) {
	const newState = {
		...state,
		flows: {
			...state.flows,
			[action.payload.flowId]: {
				...state.flows[action.payload.flowId],
				deleteError: true,
				deleteErrorDetail: action.payload
			}
		}
	};
	return newState;
}

function reduceDeleteFlowSuccess(state, action) {
	const {
		[action.payload.flowId]: deletedFlow,
		...flows
	} = state.flows;
	return {
		...state,
		flows
	};
}

export const flows = (state, action) => {
	state = state || initialState;
	switch (action.type) {
	//
	// Flows
	//
		case actions.FETCH_FLOW:
			return reduceFetchFlow(state, action);
		case actions.FETCH_FLOW_SUCCESS:
			return reduceFetchFlowSuccess(state, action);
		case actions.FETCH_FLOW_ERROR:
			return reduceFetchFlowError(state, action);
			//
			// Flow Node Handlers
			//
		case actions.FETCH_FLOW_NODE_HANDLERS:
			return reduceFetchFlowNodeHandlers(state);
		case actions.FETCH_FLOW_NODE_HANDLERS_SUCCESS:
			return reduceFetchFlowNodeHandlersSuccess(state, action);
		case actions.FETCH_FLOW_NODE_HANDLERS_ERROR:
			return reduceFetchFlowNodeHandlersError(state, action);
			//
			// Flow-Trigger Definitions
			//
		case actions.FETCH_FLOW_TRIGGER_DEFINITIONS:
			return reduceFetchFlowTriggerDefinitions(state);
		case actions.FETCH_FLOW_TRIGGER_DEFINITIONS_SUCCESS:
			return reduceFetchFlowTriggerDefinitionsSuccess(state, action);
		case actions.FETCH_FLOW_TRIGGER_DEFINITIONS_ERROR:
			return reduceFetchFlowTriggerDefinitionsError(state, action);
			//
			// Validate flow
			//
		case actions.VALIDATE_FLOW:
			return reduceValidateFlow(state);
		case actions.VALIDATE_FLOW_SUCCESS:
			return reduceValidateFlowSuccess(state, action);
		case actions.VALIDATE_FLOW_ERROR:
			return reduceValidateFlowError(state, action);
		case actions.CLEAR_FLOW_VALIDATION:
			return clearValidateFlow(state);
			//
			// Save flow
			//
		case actions.SAVE_FLOW:
			return reduceSaveFlow(state, action);
		case actions.SAVE_FLOW_SUCCESS:
			return reduceSaveFlowSuccess(state, action);
		case actions.SAVE_FLOW_ERROR:
			return reduceSaveFlowError(state, action);
		case actions.SAVE_FLOW_COMPLETED:
			return reduceSaveFlowCompleted(state, action);
			//
			// Create flow
			//
		case actions.NEW_ENDPOINT_FLOW:
		case actions.NEW_UNBOUND_FLOW:
			return reduceNewFlow(state, action);
		case actions.CREATE_ENDPOINT_FLOW:
		case actions.CREATE_UNBOUND_FLOW:
			return reduceCreateFlow(state, action);
			//
			// Debug Flow
			//
		case actions.DEBUG_FLOW_START:
			return reduceDebugFlowStart(state);
		case actions.DEBUG_FLOW_RESPOND:
			return reduceDebugFlowRespond(state, action);
		case actions.DEBUG_FLOW_STOP:
			return reduceDebugFlowStop(state);
		case actions.DEBUG_FLOW_CLEAR:
			return reduceDebugFlowClear(state);
		case actions.DEBUG_FLOW_ERROR:
			return reduceDebugFlowError(state, action);
		//
		// Delete flow
		//
		case actions.DELETE_FLOW_SUCCESS:
			return reduceDeleteFlowSuccess(state, action);
		case actions.DELETE_FLOW_ERROR:
			return reduceDeleteFlowError(state, action);
			//
			// Not interested
			//
		default:
			return state;
	}
};
